// =============================
// Used in quotes Section
// =============================

// window.jQuery = require('jquery');
// require('../vendor/sly');

// // A $( document ).ready() block.
// $( document ).ready(function() {
//     var options = {
//         horizontal: 1,
//         smart: 1,
//         itemNav: 'basic',
//         speed: 300,
//         mouseDragging: 1,
//         touchDragging: 1,
//         scrollBar: $('.scrollbar'),
//         scrollBy: 0,
//         elasticBounds: 1,
// 		dragHandle: 1,
// 		dynamicHandle: 1,
// 		clickBar: 1,
//     };

//     setTimeout(function(){
//         $('.frame').sly(options);
//     }, 1500);

// });

import Swiper from 'swiper/bundle';

// import Swiper styles

$(document).ready(function () {
    const swiper = new Swiper('.mySwiper', {
        // Optional parameters
        direction: "horizontal",
        // centeredSlides: true,
        loop: false,
        slidesPerView: 4,
        spaceBetween: 64,
        initialSlide: Math.floor($(".swiper-slide").length / 4),
        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
            dragSize: 500,
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1.5,
                spaceBetween: 26,
                initialSlide: 0,
                scrollbar: {
                    dragSize: 104
                },
            },
            767: {
                slidesPerView: 2.5,
                spaceBetween: 44,
                initialSlide: 0,
                scrollbar: {
                    dragSize: 200
                },
            },
            992: {
                // initialSlide: Math.floor($(".swiper-slide").length / 2.5)
            }
        }
    });

    var max_height = 0;
    $(".section-quotes--block--text").map((index, item) => {
        if ($(item).outerHeight(true) > max_height) {
            max_height = $(item).outerHeight(true);
        }
    });

    $(".section-quotes--block--text").map((index, item) => {
        $(item).css({ "height": max_height });
    });

});